import { Entity } from '@backstage/catalog-model';
import { EntityFilter } from '@backstage/plugin-catalog-react';

export class ApiRoutableFilter implements EntityFilter {
  constructor(readonly value: string) {}

  getCatalogFilters() {
    // Backend query filter
    return { 'metadata.labels.api-routable': this.value };
  }

  filterEntity(entity: Entity): boolean {
    const entityValue = entity.metadata.labels?.['api-routable'];
    if (!entityValue) return false;

    return String(entityValue).toLowerCase() === String(this.value).toLowerCase();
  }
}

